export function currentAccountConfig(byAccount, selectedAccount, pathname) {
  const route = pathname.match(/\/accounts\/([1-9]\d*)(?:\/|$)/)?.[1];
  if (!route || !Number.isSafeInteger(Number(route))) return {};
  if (selectedAccount != null && String(selectedAccount) !== route) return {};
  if (!byAccount || !Object.hasOwn(byAccount, route) || !byAccount[route] || typeof byAccount[route] !== 'object') return {};
  return byAccount[route];
}

export function configuredAccountId(byAccount, selectedAccount, pathname) {
  const config = currentAccountConfig(byAccount, selectedAccount, pathname);
  if (!Object.keys(config).length) return '';
  return pathname.match(/\/accounts\/([1-9]\d*)(?:\/|$)/)[1];
}
